<script>
import trainStatus from "@/components/visionTrainTrack/trainStatus.vue";
import PagenationContainer from "@/components/common/PagenationContainer.vue";
import intPage from "@/mixin/intPage.js";

import cloneDeep from "lodash/cloneDeep";
import forOwn from "lodash/forOwn";
import moment from "moment";
import { MapTrackState } from "@/common/util";
export default {
  mixins: [intPage],
  components: {
    trainStatus,
    PagenationContainer
  },
  data() {
    const ROLE_GROUP_OPTOMETRIST =
      localStorage.getItem("roles").indexOf("ROLE_GROUP_OPTOMETRIST") > -1;
    const ROLE_AGENT_OPTOMETRIST =
      localStorage.getItem("roles").indexOf("ROLE_AGENT_OPTOMETRIST") > -1 ||
      localStorage.getItem("roles").indexOf("ROLE_STATION_MANAGER") > -1;
    const stationId = this.$cookie.get("stationId");
    const trainActivePageNumber =
      sessionStorage.getItem("trainActivePageNumber") || 1;
    const tempSearch = sessionStorage.getItem("searchFormData")
      ? JSON.parse(sessionStorage.getItem("searchFormData"))
      : {
          name: undefined,
          phone: undefined,
          trainingCompleted: undefined,
          trackState: "NEED_REVIEW",
          start: undefined,
          end: undefined,
          provinceCity: undefined,
          stationId: undefined,
          dateRange: [
            moment()
              .subtract(6, "days")
              .format("YYYY-MM-DD"),
            moment().format("YYYY-MM-DD")
          ]
        };
    return {
      searchFormData: tempSearch,
      ROLE_GROUP_OPTOMETRIST,
      ROLE_AGENT_OPTOMETRIST,
      stationId,
      ProvinceList: [],
      tableData: [],
      basicSearchArray: [
        {
          label: "姓名",
          keyName: "name"
        },
        {
          label: "手机号",
          keyName: "phone"
        }
      ],
      districtArray: [
        {
          label: "省份搜索",
          keyName: "districtProvince",
          children: []
        },
        {
          label: "",
          keyName: "districtCity",
          children: []
        }
      ],
      trainingCompletedArray: [
        {
          label: "训练计划",
          keyName: "trainingCompleted",
          value: "all",
          children: [
            {
              label: "全部",
              keyName: ""
            },
            {
              label: "完成",
              keyName: "true"
            },
            {
              label: "未完成",
              keyName: "false"
            }
          ]
        },
        {
          label: "处理结果",
          keyName: "trackState",
          value: "NEED_REVIEW",
          children: [
            {
              label: "全部",
              keyName: "all"
            },
            {
              label: "已处理",
              keyName: "REVIEWED"
            },
            {
              label: "未处理",
              keyName: "NEED_REVIEW"
            }
          ]
        }
      ],
      addingUser: false,
      buttonArray: [
        {
          text: "今天",
          key: "today"
        },
        {
          text: "昨天",
          key: "yesterday"
        },
        {
          text: "最近一周",
          key: "week"
        }
      ],
      radio: 0,
      pageCount: 0,
      activePage: parseInt(trainActivePageNumber),
      totalElements: 0,
      basicSearchArray: [
        {
          label: "姓名",
          keyName: "name",
          type: "text"
        },
        {
          label: "手机号",
          keyName: "phone",
          type: "text"
        }
      ],
      agentOptSearchArray: [
        {
          label: "训练计划",
          keyName: "trainingCompleted",
          type: "radio",
          value: "",
          children: [
            {
              label: "全部",
              keyName: ""
            },
            {
              label: "完成",
              keyName: "true"
            },
            {
              label: "未完成",
              keyName: "false"
            }
          ]
        },
        {
          label: "处理结果",
          keyName: "trackState",
          type: "radio",
          value: "NEED_REVIEW",
          children: [
            {
              label: "全部",
              keyName: ""
            },
            {
              label: "已处理",
              keyName: "REVIEWED"
            },
            {
              label: "未处理",
              keyName: "NEED_REVIEW"
            }
          ]
        }
      ],
      groupOptSearchArray: [
        {
          label: "省市搜索",
          keyName: "provinceCity",
          children: [],
          type: "cascader"
        },
        {
          label: "医疗机构",
          keyName: "stationId",
          type: "select",
          value: "",
          children: []
        },
        {
          label: "处理结果",
          keyName: "trackState",
          type: "radio",
          value: "NEED_REVIEW",
          children: [
            {
              label: "全部",
              keyName: ""
            },
            {
              label: "已处理",
              keyName: "REVIEWED"
            },
            {
              label: "未处理",
              keyName: "NEED_REVIEW"
            }
          ]
        }
      ]
    };
  },
  computed: {
    activeSearchArray() {
      if (this.ROLE_GROUP_OPTOMETRIST) {
        return this.groupOptSearchArray;
      } else if (this.ROLE_AGENT_OPTOMETRIST) {
        return this.agentOptSearchArray;
      }
    }
  },
  created() {
    // 如果从患者详情页跳转过来，重置搜索条件并使用患者姓名进行搜索
    if (this.$route.query.name) {
      this.searchFormData = {
        name: this.$route.query.name,
        phone: undefined,
        trainingCompleted: undefined,
        trackState: "",
        start: undefined,
        end: undefined,
        provinceCity: undefined,
        stationId: undefined,
        dateRange: undefined
      };
    }
    for (let item in this.basicSearchArray) {
      if (this.searchFormData[this.basicSearchArray[item].keyName]) {
        this.basicSearchArray[item].value = this.searchFormData[
          this.basicSearchArray[item].keyName
        ];
      }
    }
    if (this.ROLE_GROUP_OPTOMETRIST) {
      for (let item in this.groupOptSearchArray) {
        if (
          this.searchFormData[this.groupOptSearchArray[item].keyName] !==
          undefined
        ) {
          this.groupOptSearchArray[item].value = this.searchFormData[
            this.groupOptSearchArray[item].keyName
          ];
        }
      }
      console.log("this.ROLE_GROUP_OPTOMETRIST", this.searchFormData);
      if (
        this.searchFormData.provinceCity &&
        this.searchFormData.provinceCity.length > 0
      ) {
        this.lodaStationList(
          this.searchFormData.provinceCity[0],
          this.searchFormData.provinceCity[1]
        );
      }
    } else if (this.ROLE_AGENT_OPTOMETRIST) {
      for (let item in this.agentOptSearchArray) {
        if (
          this.searchFormData[this.agentOptSearchArray[item].keyName] !==
          undefined
        ) {
          this.agentOptSearchArray[item].value = this.searchFormData[
            this.agentOptSearchArray[item].keyName
          ];
        }
      }
    }

    this.loadProvice();
    this.loadData();

    // this.$nextTick(() => {
    //   document.addEventListener("keyup", this.onEnterForSearch);
    // });
  },
  // destroyed() {
  //   document.removeEventListener("keyup", this.onEnterForSearch);
  // },
  watch: {
    "$route.query.name"(newName) {
      if (newName) {
        this.searchFormData = {
          name: newName,
          phone: undefined,
          trainingCompleted: undefined,
          trackState: "",
          start: undefined,
          end: undefined,
          provinceCity: undefined,
          stationId: undefined,
          dateRange: undefined
        };
        for (let item in this.basicSearchArray) {
          this.basicSearchArray[item].value =
            this.searchFormData[this.basicSearchArray[item].keyName];
        }
        this.loadData();
      }
    }
  },
  methods: {
    async loadData() {
      let params = {
        page: this.activePage - 1
      };
      for (let key in this.searchFormData) {
        if (key === "provinceCity") {
          if (this.searchFormData[key]) {
            if (this.searchFormData[key][0]) {
              params.provinceId = this.searchFormData[key][0];
            }
            if (this.searchFormData[key][1]) {
              params.districtId = this.searchFormData[key][1];
            }
          }
        } else if (key === "dateRange" && this.searchFormData.dateRange) {
          if (this.searchFormData.dateRange[0]) {
            params.start = this.searchFormData.dateRange[0];
          }
          if (this.searchFormData.dateRange[1]) {
            params.end = this.searchFormData.dateRange[1];
          }
        } else if (key === "trainingCompleted") {
          if (this.searchFormData.trainingCompleted === "true") {
            params[key] = true;
          } else if (this.searchFormData.trainingCompleted === "false") {
            params[key] = false;
          }
        } else if (this.searchFormData[key] !== undefined) {
          params[key] = this.searchFormData[key];
        }
      }
      sessionStorage.setItem(
        "searchFormData",
        JSON.stringify(this.searchFormData)
      );
      console.log("loadData", this.searchFormData);
      if (this.ROLE_AGENT_OPTOMETRIST || this.stationId) {
        params.stationId = this.stationId;
      }
      params.all = false;
      let data = await this.$http.getPatientTrackList(params);
      if (data && data.content) {
        this.pageCount = data.totalPages;
        this.totalElements = data.totalElements;
        let newTableData = [];
        data.content.forEach(item => {
          let note = "";
          if (
            item.remark ||
            item.customRemark ||
            item.trainingRemark ||
            item.customTrainingRemark
          ) {
            note = `训练情况：${
              item.trainingRemark ? item.trainingRemark + "#" : ""
            }${item.customTrainingRemark || ""}；
                处理方式：${
                  item.remark ? item.remark + "#" : ""
                }${item.customRemark || ""}`;
          }

          newTableData.push({
            trainingAt: item.trainingAt,
            name: item.name,
            phone: item.phone,
            trackState: item.trackState,
            trackName: item.handler ? item.handler.name : null,
            id: item.patientId,
            remark: note,
            gameTrack: item.gameTrack,
            patientId: item.patientId,
            trackId: item.trackId,
            stationId: item.stationId,
            stationName: item.stationName
          });
        });
        this.tableData = newTableData;
      }
    },
    onSearch(done) {
      this.activePage = 1;
      sessionStorage.setItem("trainActivePageNumber", 1);
      this.loadData();
    },
    async loadProvice() {
      if (this.ROLE_GROUP_OPTOMETRIST) {
        let province = this.groupOptSearchArray;
        console.log("this.groupOptSearchArray", this.groupOptSearchArray);
        const ProvinceList = await this.$http.getProvinceList("optometrist");
        if (ProvinceList.length > 0) {
          const provinceChildren = ProvinceList.map(o => {
            return {
              label: o.name,
              keyName: o.id,
              value: o.id,
              children: o.sons.map(o => {
                return {
                  label: o.name,
                  value: o.id
                };
              }),
              id: o.id,
              name: o.name
            };
          });
          province.forEach(o => {
            if (o.keyName === "provinceCity") {
              o.children = provinceChildren;
            }
          });
          this.ProvinceList = provinceChildren;
        }
      }
    },
    async onSearchChange(data) {
      if (data.provinceCity && data.provinceCity.length > 0) {
        console.log("onSearchChange", data);
        await this.lodaStationList(data.provinceCity[0], data.provinceCity[1]);
      } else {
        this.groupOptSearchArray[1].children = [];
        data.stationId = undefined;
      }
      forOwn(data, (value, key) => {
        this.searchFormData[key] = data[key];
      });
    },
    async lodaStationList(provinceId, cityId) {
      console.log(provinceId, cityId);
      const params = {
        provinceId,
        cityId
      };
      const StationList = await this.$http.getDoctorStationList(params);
      this.groupOptSearchArray[1].children = StationList.map(o => {
        return {
          keyName: o.stationUUID,
          label: o.name
        };
      });
      console.log("StationList:", StationList);
    },
    onClick(row) {
      this.$router.push({
        path: `${this.$route.path}/visionTrainTrackDetail/${row.patientId}/${row.stationId}/${row.trackId}`
      });
    },
    onOperationClick(row, key) {
      switch (key) {
        case "today":
          this.searchFormData.dateRange = [
            moment().format("YYYY-MM-DD"),
            moment().format("YYYY-MM-DD")
          ];
          break;
        case "yesterday":
          this.searchFormData.dateRange = [
            moment()
              .subtract(1, "days")
              .format("YYYY-MM-DD"),
            moment()
              .subtract(1, "days")
              .format("YYYY-MM-DD")
          ];
          break;
        case "week":
          this.searchFormData.dateRange = [
            moment()
              .subtract(6, "days")
              .format("YYYY-MM-DD"),
            moment().format("YYYY-MM-DD")
          ];
          break;
      }
    },
    handleCurrentChange(val) {
      this.activePage = val;
      sessionStorage.setItem("trainActivePageNumber", val);
      this.loadData();
    },
    onEnterForSearch(e) {
      if (e.key == "Enter") {
        // this.onSearch();
      }
    }
  }
};
</script>
<template>
  <div class="trainTrackIndex">
    <div class="TextGroup">
      <searchFormNew
        class="searchFormNew"
        @onChange="onSearchChange"
        @onSearch="onSearch"
        :searchItemArray="basicSearchArray"
      />
      <div class="dataSearch">
        <span>时间选择：</span>
        <el-date-picker
          v-model="searchFormData.dateRange"
          @keyup.enter.native="onSearch"
          size="medium"
          class="dateRange"
          type="daterange"
          range-separator="至"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
        <textButtonGroup
          class="dataButton"
          :buttonArray="buttonArray"
          @onOperationClick="onOperationClick"
        />
      </div>
      <el-button type="primary" class="searchButton" @click="onSearch" size="mini">搜索</el-button>
    </div>

    <searchFormNew
      class="searchFormNew"
      @onChange="onSearchChange"
      :searchItemArray="activeSearchArray"
      @onSearch="onSearch"
    />
    <div class="statistics">
      <i class="el-icon-info totalResult"></i>
      查询结果：
      <span class="totalResult">{{totalElements}}</span> 个
    </div>
    <el-table
      :data="tableData"
      @row-click="onClick"
      class="visionTrainTrackTable"
      :header-cell-style="{ 'padding-left': '5px',color: 'rgba(0,0,0,0.65)','font-size': '14px', 'background-color': '#fafafa !important'}"
      :cell-style="{'padding-left': '5px', 'padding-bottom': '3px', 'padding-top': '5px'}"
      header-cell-class-name="visionTrainTrackListHeaderCell"
      cell-class-name="visionTrainTrackListBodyCell"
    >
      <el-table-column prop="trainingAt" align="left" label="训练日期" width="90"></el-table-column>
      <el-table-column prop="name" align="left" label="患者信息" width="180">
        <template slot-scope="scope">
          <div>
            <div>
              {{scope.row.name}}
              <span style="float: right">{{scope.row.phone}}</span>
            </div>
            <!-- <div>
              {{scope.row.phone}}
            </div>-->
            <div>{{scope.row.stationName}}</div>
          </div>
          <!-- <span>
            <el-popover
              placement="top-start"
              width="200"
              title= '医疗机构：'
              trigger="hover"
              :content="scope.row.stationName"
            >
              <span slot="reference" class="ViewButton" @click.stop>{{scope.row.name}}</span>
            </el-popover>
          </span>-->
        </template>
      </el-table-column>
      <!-- <el-table-column prop="phone" align="left" label="手机号" width="120"></el-table-column> -->
      <el-table-column prop="trackName" align="left" label="处理人" width="90"></el-table-column>
      <el-table-column prop="trackState" align="left" label="状态" min-width="440">
        <template slot-scope="scope">
          <div>
            <trainStatus
              v-if="scope.row.gameTrack"
              :key="scope.row.patientId + scope.row.trainingAt"
              class="trainStatus"
              :propData="scope.row"
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="remark" align="left" label="处理结果" width="80">
        <template slot-scope="scope">
          <span v-if="scope.row.trackState === 'REVIEWED'" class="ViewButton">
            <el-popover
              placement="top-start"
              title="备注"
              width="200"
              trigger="hover"
              :content="scope.row.remark"
            >
              <span slot="reference" class="ViewButton" @click.stop>查看</span>
            </el-popover>
          </span>
          <span v-else-if="scope.row.trackState === 'NEED_REVIEW'">未处理</span>
        </template>
      </el-table-column>
    </el-table>
    <PagenationContainer v-if="pageCount > 1">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page="activePage"
        :page-count="pageCount"
        layout="prev, pager, next, jumper"
      ></el-pagination>
    </PagenationContainer>
  </div>
</template>

<style lang="scss">
@import "@/css/color.scss";

.trainTrackIndex {
  .TextGroup {
    display: flex;
    flex-wrap: wrap;
    .dataSearch {
      margin-left: 5px;
      line-height: 55px;
      .dataButton {
        margin-left: 10px;
        display: inline-block;
      }
      .dateRange {
        width: 220px;
        .el-range-editor--mini.el-input__inner {
          height: 36px !important;
        }
        .el-range-editor.is-active,
        .el-range-editor.is-active:hover {
          border-color: #00c1de;
        }
        .el-date-table td.today span {
          color: #00c1de;
        }
      }
    }

    .searchButton {
      margin: 10px;
      font-size: 14px;
      margin-left: 20px;
      width: 60px;
      height: 36px;
      background: rgba(0, 193, 222, 1);
      border-color: #00c1de;
      border-radius: 4px;
    }
  }
  .radioGroup {
    margin-top: -25px;
  }
  .statistics {
    float: right;
    margin-right: 30px;
    margin-top: -20px;
    margin-bottom: 10px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.45);
    line-height: 22px;
    .totalResult {
      color: #00c1de;
    }
  }
  .searchFormNew {
    // border: 1px;
    // height: 50px;
    // margin: 0 1%;
    .labelInput {
      width: 120px;
    }
    .el-input__inner {
      padding-right: 10px;
    }
  }

  .visionTrainTrackTable {
    margin: 10px 1%;
    border: 1px;
    width: 98%;
    .trainStatus {
      display: flex;
    }
    th > .cell {
      font-weight: bold;
    }
    .ViewButton {
      color: #00c1de;
      cursor: pointer;
    }
    .el-table__body tr:hover > td {
      background-color: #e6f7ff !important;
      cursor: pointer;
    }

    .el-table__body tr.current-row > td {
      background-color: #e6f7ff !important;
      cursor: pointer;
    }
    .visionTrainTrackListHeaderCell {
      > .cell {
        padding-left: 0px;
        padding-right: 0px;
      }
    }
    .visionTrainTrackListBodyCell {
      > .cell {
        padding-left: 0px;
        padding-right: 0px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/visionTrainTrack/index.vue